/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Admin_HintInputs */



/**
* | output |
* | --- |
* | "Everything, including who gets access, the bot token and deleting the team." |
*
* @param {Preset_Admin_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const preset_admin_hint = /** @type {((inputs?: Preset_Admin_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Admin_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Может всё, включая выдачу доступа, токен бота и удаление команды.")
	return /** @type {LocalizedString} */ ("Everything, including who gets access, the bot token and deleting the team.")
});